//收益报表
const repProfitZh = {
  repProfitLang: {
    收益报表: '收益报表',
    站点汇总展示所有站点报表数据支持按日展示31天按月展示一年内数据: '站点汇总展示所有站点报表数据，支持按日展示31天，按月展示一年内数据。',
    站点汇总: '站点汇总',
    单站报表: '单站报表',
    时间范围: '时间范围',
    开始日期: '开始日期',
    结束日期: '结束日期',
    开始月份: '开始月份',
    结束月份: '结束月份',
    开始年份: '开始年份',
    结束年份: '结束年份',
    请选择: '请选择',
    查询: '查询',
    重置: '重置',
    报表导出: '报表导出',
    站点名称: '站点名称',
    '充电价格(元)': '充电价格(元)',
    尖: '尖',
    峰: '峰',
    平: '平',
    谷: '谷',
    总: '总',
    '放电价格(元)': '放电价格(元)',
    '实际收益(元)': '实际收益(元)',
    暂无数据: '暂无数据',
    按日: '按日',
    按月: '按月',
    按年: '按年',
    请选择时间范围: '请选择时间范围！',
    报表类型: '报表类型',
    选择站点: '选择站点',
    日期: '日期',
    日报表: '日报表',
    月报表: '月报表',
    年报表: '年报表',
    请选择站点: '请选择站点！',
    总计: '总计'
  }
}
export default repProfitZh
